<p>valider-cra-client-final works!</p>
